import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Reveal, useParallax, AnimatedDivider, Magnetic } from './effects';

// Different image — chef plating warm, single-subject editorial (not used elsewhere)
const PROMISE_IMAGE =
  '/site/the-promise.webp';

const ThePromise = () => {
  const imgRef = useParallax(0.08);

  return (
    <section className="relative py-28 lg:py-44 bg-[#F5F3EF] overflow-hidden">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Left: image with parallax */}
        <div className="relative lg:col-span-6">
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm shadow-[0_30px_80px_-30px_rgba(114,39,45,0.35)]">
            <img
              ref={imgRef}
              src={PROMISE_IMAGE}
              alt=""
              className="absolute inset-0 w-full h-full object-cover will-change-transform"
              style={{ transform: 'scale(1.1)' }}
            />
            <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[#0A0A0A]/15" />
          </div>

          <div className="absolute -top-10 -left-2 lg:-left-10 font-display text-[140px] lg:text-[220px] leading-none text-[#9A7F4F]/[0.09] select-none pointer-events-none numeric">
            03
          </div>
        </div>

        {/* Right: copy */}
        <div className="lg:col-span-6">
          <div className="flex items-center gap-3 mb-7">
            <AnimatedDivider width="3rem" />
            <Reveal delay={100} y={8} duration={700}>
              <span className="text-[10.5px] tracking-[0.34em] uppercase text-[#9A7F4F] font-medium">
                Tanıdık Geldi mi?
              </span>
            </Reveal>
          </div>

          <Reveal delay={150}>
            <h2
              className="font-display text-[36px] sm:text-[44px] lg:text-[60px] text-[#1A1A1A] leading-[1.04] tracking-[-0.02em]"
              style={{ fontWeight: 500 }}
            >
              Yemek bir <span className="italic font-light">gider</span> değil —
              <br className="hidden sm:block" /> çalışan memnuniyetinin{' '}
              <span className="italic font-light text-[#9A7F4F]">temelidir</span>.
            </h2>
          </Reveal>

          <Reveal delay={350}>
            <p className="mt-7 text-[15.5px] lg:text-[16.5px] text-[#1A1A1A]/72 max-w-xl leading-[1.7]">
              Çoğu kurum yemek tedarikçisini bir gider olarak görür. Oysa kötü bir
              yemek operasyonu üretim duruşu, çalışan kaybı ve itibar zedelenmesine
              yol açar. Tarhun yemek değil — kesintisiz işleyen bir{' '}
              <em className="font-display italic text-[#1A1A1A]">sistem</em>{' '}
              teslim eder.
            </p>
          </Reveal>

          <Reveal delay={500}>
            <Magnetic strength={0.18}>
              <Link
                to="/tasima-yemek"
                className="group mt-10 inline-flex items-center gap-2 text-[#1A1A1A] text-[12.5px] tracking-[0.18em] uppercase font-medium border-b border-[#1A1A1A]/30 pb-1.5 hover:border-[#9A7F4F] hover:text-[#9A7F4F] transition-colors duration-300"
              >
                Çözümümüzü Gör
                <ArrowRight
                  size={14}
                  className="transition-transform group-hover:translate-x-1"
                />
              </Link>
            </Magnetic>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ThePromise;
